import type { IRootState } from '@store/slices';
import type { IWorkingSite } from '@interfaces/IWorkingSite';

export const selectWorkingSite = (state: IRootState): IWorkingSite | null =>
  state.siteReducer.workingSite;

export const selectSiteId = (state: IRootState): string | undefined =>
  state.siteReducer.workingSite?.siteId;

export const selectSiteTz = (state: IRootState): string | undefined =>
  state.siteReducer.workingSite?.tz;

export const selectTrusstorProjectId = (state: IRootState): string | undefined =>
  state.siteReducer.workingSite?.trusstorProjectId;
